// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"972b16ba","31":"ead671cf","156":"a1a14bd9","246":"c4efd556","297":"bbcdf378","420":"ed74f4ba","546":"daeb7d11","620":"287b8278","800":"45bb4306","882":"1cee271d","886":"880d5893","892":"98c7f327"}[chunkId] + ".chunk.js";
};